module.exports = __webpack_public_path__ + "static/media/key-dropoff.cb3318a6.svg";